/**
 * Clerk ID'leri (user_3FuL...) ham halde görünmesin diye temiz isim döndürür.
 */
export function formatStudentName(rawName: string | null | undefined, fallback = 'Öğrenci'): string {
  if (!rawName || !rawName.trim()) return fallback;
  const name = rawName.trim();
  // Eğer Clerk user_id formatındaysa (user_XXX) ham ID göstermek yerine temiz fallback döndür
  if (name.startsWith('user_') && name.length > 20) {
    return `${fallback} (#${name.slice(5, 10)})`;
  }
  return name;
}

/**
 * Öğrencilerin diğer öğrencilerin isimlerini ilk 2 harf + sabit 3 yıldız (***) şeklinde görmesi için maskeler.
 * Örnek: "Ahmet Yılmaz" -> "Ah*** Yı***"
 * Örnek: "Ali Can" -> "Al*** Ca***"
 */
export function maskStudentName(rawName: string | null | undefined, fallback = 'Öğ***'): string {
  if (!rawName || !rawName.trim()) return fallback;
  const name = rawName.trim();
  if (name.startsWith('user_') && name.length > 20) {
    return fallback;
  }
  const words = name.split(/\s+/);
  return words.map(w => {
    if (!w) return '';
    const prefix = w.slice(0, 2);
    return `${prefix}***`;
  }).join(' ');
}

